"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");exports.__esModule=true;exports.default=_default;var _lib=require("@fusioncharts/core/src/lib");var _discrete=_interopRequireDefault(require("../_internal/components/legend/discrete"));function _default(chart){var legend;(0,_lib.componentFactory)(chart,_discrete.default,"legend");legend=chart.getChildren("legend")[0];legend.configure();chart.addToEnv("legend",legend);if(!chart.config.showLegend){legend.remove()}}


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/charts/src/factories/legend.js
// module id = +SZj
// module chunks = 5